module.exports = __webpack_public_path__ + "static/media/master-visa.de1e1ba8.png";